import { css } from "styled-components";
import { CardImage, CardTitle, CardBody, CardDescription } from "../../../..";
export const leagueClientSkin = (chroma) => css `
  & {
    aspect-ratio: 16/9;
    position: relative;
    border: 1px solid ${chroma.palette.borderGrey};
    box-shadow: 0 0 0 1px rgb(0 10 19 / 85%);
    cursor: pointer;

    &.card-large {
      aspect-ratio: unset;
      grid-column: 1/3;
      grid-row: 1/3;
      ${CardBody} {
        background: linear-gradient(180deg, transparent, rgb(0 0 0 / 60%) 40%, rgb(0 0 0 / 90%) 100%);

        ${CardTitle} {
          ${chroma.typography.h2};
          color: ${chroma.palette.gold2};
        }
        ${CardDescription} {
          display: block;
        }
      }

      &:hover {
        ${CardBody} {
          ${CardTitle} {
            color: ${chroma.palette.gold1};
          }
          ${CardDescription} {
            color: ${chroma.palette.gold2};
          }
        }
      }
    }

    ${CardImage} {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border: 1px solid rgb(0 10 19 / 85%);

      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }
    ${CardBody} {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: linear-gradient(180deg, transparent, rgb(0 0 0 / 50%) 40%, rgb(0 0 0 / 80%) 100%);
      padding: 2.5vw 1.5vw 1.2vw;

      ${CardTitle} {
        ${chroma.typography.h4};
        ${chroma.typography.modifierPreserveCase};
        color: ${chroma.palette.gold2};
        text-shadow:
          0 0 1px rgb(0 0 0 / 50%),
          0 0 2px rgb(0 0 0 / 80%),
          0 0 4px rgb(0 0 0 / 100%);
        transition: color 0.1s linear;
      }

      ${CardDescription} {
        ${chroma.typography.textMedium};
        color: ${chroma.palette.gold3};
        display: none;
      }
    }

    /* TODO:  MRKP-1647: update item.action.type below to use LcActionType.Video, */
    &.action-youtube_video {
      .icon-action-play-video {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 36px;
        height: 36px;
        transform: translate(-50%, -50%);
        background: rgb(255 255 255);
        box-shadow: rgb(0 0 0 / 20%) 0 0 1px 4px;
        border-radius: 35%;
        transition:
          filter 0.2s ease-in 0s,
          transform 0.1s ease-in 0s;

        &::after {
          content: " ";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 0;
          height: 0;
          background: transparent;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 9px solid rgb(0 0 0);
          filter: blur(0.5px);
        }
      }

      /* large video cards */
      &.card-large {
        .icon-action-play-video {
          width: 64px;
          height: 64px;

          &::after {
            border-top-width: 8px;
            border-bottom-width: 8px;
            border-left-width: 14px;
          }
        }
      }
    }

    /* standard card hover state styles */
    &:hover {
      filter: saturate(1.15) brightness(1.15);
      border: 1px solid ${chroma.palette.gold3};

      .overlay {
        ${CardTitle} {
          color: ${chroma.palette.gold1};
        }
      }

      /* TODO:  MRKP-1647: update below to use LcActionType.Weblink, */
      &.action-weblink::after {
        filter: drop-shadow(0 0 0.7px black) drop-shadow(0 0 1px black) brightness(1.2);
      }

      /* TODO:  MRKP-1647: update item.action.type below to use LcActionType.Video, */
      &.action-youtube_video::after {
        .icon-action-play-video {
          transform: translate(-50%, -50%) scale(1.05);
        }
      }
    }

    /* External Link Icon for weblinks */

    /* TODO:  MRKP-1647: update item.action.type below to use LcActionType.WebLink, */
    &.action-weblink {
      .icon-link {
        position: absolute;
        top: 7px;
        right: 7px;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map